import { useUpdateReservationCustomerNoteMutation } from "@stepapp/core";
import { CategoryType } from "@stepapp/core/apiTypes";
import { spacing } from "@stepapp/ui";
import { useNavigation } from "expo-router";
import { useCallback, useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import ReservationNote from "../../components/Service/ReservationNote";
import EditContentContainer from "./EditContentContainer";

type StatusType = "success" | "loading" | "";

type EditReservationNoteProps = {
  customerNote: string;
  setDetailsStatus: (v: StatusType) => void;
  reservationId: string;
  categoryType?: CategoryType | null;
  handleGoBack: () => void;
  refetch: () => void;
};

const EditReservationNote = ({
  customerNote,
  setDetailsStatus,
  reservationId,
  categoryType,
  handleGoBack,
  refetch,
}: EditReservationNoteProps) => {
  const navigation = useNavigation();
  const [newNote, setNewNote] = useState(customerNote);
  const [updateReservationNote, { loading }] = useUpdateReservationCustomerNoteMutation();

  const isDisabled = newNote === customerNote;

  const handleSaveChanges = useCallback(async () => {
    setDetailsStatus("loading");

    await updateReservationNote({
      variables: {
        reservationId,
        note: newNote,
      },
    });

    refetch();
    setDetailsStatus("success");
  }, [updateReservationNote, reservationId, newNote, setDetailsStatus, refetch]);

  const handleClose = useCallback(() => {
    handleGoBack();
    setDetailsStatus("");
  }, [setDetailsStatus, handleGoBack]);

  useEffect(() => {
    setNewNote(customerNote);
  }, [customerNote]);

  const noteAsModal = navigation?.getState()?.routes[1]?.name === "edit-reservation";

  return (
    <EditContentContainer
      questionType="customerNote"
      handleSaveChanges={handleSaveChanges}
      loading={loading}
      handleClose={handleClose}
      isSubmitDisabled={isDisabled}
      noteAsModal={noteAsModal}
      categoryType={categoryType}
    >
      <ReservationNote
        type="edit"
        note={newNote}
        onChangeText={setNewNote}
        containerStyles={styles.container}
        categoryType={categoryType}
      />
    </EditContentContainer>
  );
};

export default EditReservationNote;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: spacing.unit * 2.5,
  },
});
